import * as React from "react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { ai } from "./TelemetryService";

export interface AppInsightProps {
  connectionString: string;
  children: any;
  initialized: boolean;
  after: Function;
}

export interface AppinsightState {
  connectionString: string;
  children: any;
  initialized: boolean;
  after: Function;
}

class TelemetryProvider extends React.Component<AppInsightProps, AppinsightState> {
  constructor(props: AppInsightProps, context: AppinsightState) {
    super(props, context);
    this.state = {
      initialized: false,
      connectionString: "",
      after: () => {},
      children: null,
    };
  }

  componentDidMount() {
    // debugger;
    let AppInsightsConnectionString = this.props.connectionString; // PUT YOUR KEY HERE
    if (!this.state.initialized && Boolean(AppInsightsConnectionString)) {
      ai.initialize(AppInsightsConnectionString);
      this.setState({ initialized: true });
    }

    this.props.after();
  }

  render() {
    const { children } = this.props;
    return <React.Fragment>{children}</React.Fragment>;
  }
}

export default withAITracking(ai.reactPlugin, TelemetryProvider, "TelemetryProvider", "telemetry");
